import { ref, unref, computed } from 'vue'

const isLoading = ref(false)

function setIsLoading(boolean) {
  isLoading.value = boolean
}

export function useLoading() {
  return {
    isLoading: computed(() => unref(isLoading)),
    setIsLoading
  }
}